import { ReactNode } from 'react';
import { IconFileDescription } from '@rossum/ui/icons/tabler';
import { Chip, SvgIcon } from '@rossum/ui/material';

type EmailCardChipProps = {
  showAttachmentError: boolean;
  label: ReactNode;
};

export const EmailCardChip = ({
  showAttachmentError,
  label,
}: EmailCardChipProps) => (
  <>
    <SvgIcon fontSize="medium">
      <IconFileDescription />
    </SvgIcon>

    <Chip
      label={label}
      color={showAttachmentError ? 'error' : 'default'}
      sx={{
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        cursor: 'inherit',
      }}
    />
  </>
);
